// extracted by mini-css-extract-plugin
module.exports = {"Button":"📚4-7-01f2Kv"};